<template>
  <div
    v-observe-visibility="{
      callback: handleVisibleCallback,
      intersection: { rootMargin: '50px' },
    }"
    :class="[
      $style.winnersMainPageSliderWrapper,
      $style[direction],
      direction,
      variant ? `variant-${variant}` : '',
    ]"
  >
    <div :class="$style.winnersMainPageSliderTitle" class="winnersTabs">
      <!-- <BitTabButton
        :class="$style.winnersMainPageSliderTitleTab"
        :active="sliderTab === WinnerTabsType.Top"
        is-fit-width
        @click="setWinnersTab(WinnerTabsType.Top)"
      >
        {{ storeCataloguePage.topWinnersTitle }}
      </BitTabButton>
      <BitTabButton
        :class="[$style.winnersMainPageSliderTitleTab, $style.winnersMainPageSliderTitleTabLatest]"
        is-fit-width
        :active="sliderTab === WinnerTabsType.Latest"
        @click="setWinnersTab(WinnerTabsType.Latest)"
      >
        {{ storeCataloguePage.latestWinnersTitle }}
      </BitTabButton> -->
      <BitMenuScrollable
        :class="$style.myGamesCategoryTabs"
        :list-class="$style.myGamesCategoryList"
        list-max-width="1192px"
      >
        <BitTabButton
          :class="$style.winnersMainPageSliderTitleTab"
          :active="sliderTab === WinnerTabsType.Top"
          is-fit-width
          color="transparent"
          @click="setWinnersTab(WinnerTabsType.Top)"
        >
          {{ storeCataloguePage.topWinnersTitle }}
        </BitTabButton>
        <BitTabButton
          :class="[
            $style.winnersMainPageSliderTitleTab,
            $style.winnersMainPageSliderTitleTabLatest,
          ]"
          color="transparent"
          is-fit-width
          :active="sliderTab === WinnerTabsType.Latest"
          @click="setWinnersTab(WinnerTabsType.Latest)"
        >
          {{ storeCataloguePage.latestWinnersTitle }}
        </BitTabButton>
      </BitMenuScrollable>
    </div>
    <div
      v-if="variant === 'table'"
      :class="$style.winnersTable"
      :style="{
        '--winners-count': countOfWinnersToShow,
      }"
    >
      <div :class="[$style.winnersTableLine, $style.winnersTableHead]">
        <span :class="$style.winnersTableGameTd">{{ storeCataloguePage.winTableGameTitle }}</span>
        <span :class="$style.winnersTableUserTd">{{ storeCataloguePage.winTableUserTitle }}</span>
        <!-- <span :class="$style.winnersTableBetTd">{{ storeCataloguePage.winTableBetTitle }}</span> -->
        <span :class="$style.winnersTableMultiTd">
          {{ storeCataloguePage.winTableMultiplayerTitle }}
        </span>
        <span :class="$style.winnersTableProfitTd">
          {{ storeCataloguePage.winTableProfitTitle }}
        </span>
      </div>
      <template v-if="isLoading || !winnersListWithLinks.length">
        <div :class="$style.winnersTableBody">
          <WinnersNowItemSkeleton
            v-for="index in countOfWinnersToShow"
            :key="index"
            style="height: 45px"
            :class="[$style.winnersTableLine, $style.winnersTableLineSkeleton]"
          />
        </div>
      </template>
      <template v-if="!isLoading">
        <BitTableWrapper :class="$style.winnersTableBody">
          <transition-group name="list-complete-table">
            <a
              v-for="winner in winnersListWithLinks"
              :key="winner.id"
              :href="winner.gameFullPath"
              :class="[$style.winnersTableLine, $style['list-complete-item']]"
              @click.prevent="openGame(winner.game)"
            >
              <span :class="$style.winnersTableGameTd">{{ winner.game.title }}</span>
              <span :class="$style.winnersTableUserTd">{{ winner.player.nickname }}</span>
              <!-- <span :class="$style.winnersTableBetTd">{{ winner.bet_amount_formatted }}</span> -->
              <span :class="$style.winnersTableMultiTd">x{{ winner.multiplayer }}</span>
              <span :class="[$style.winnersTableProfitTd, $style.winnersTableProfitValue]">
                <span>{{ winner.win_amount_formatted }}</span>
                <img
                  width="24"
                  height="24"
                  :src="getCurrencyIconUrl(winner.currency)"
                  :alt="winner.currency"
                />
              </span>
            </a>
          </transition-group>
        </BitTableWrapper>
      </template>
    </div>
    <div
      v-else
      :class="$style.winnersMainPageSlider"
      :style="{
        '--winners-count': countOfWinnersToShow,
      }"
    >
      <template v-if="isLoading">
        <div :class="$style.winnersMainPageSliderBlock" class="winnersMainPageSliderBlock">
          <WinnersNowItemSkeleton
            v-for="index in countOfWinnersToShow"
            :key="index"
            :class="$style.catalogueSliderPromotionsCard"
          />
        </div>
      </template>
      <template v-if="!isLoading">
        <transition-group name="list-complete" tag="div" :class="$style.winnersMainPageSliderBlock">
          <a
            v-for="winner in winnersListWithLinks"
            :key="winner.id"
            :href="winner.gameFullPath"
            :class="[$style.winnersMainPageSliderItem, $style['list-complete-item']]"
            @click.prevent="openGame(winner.game)"
          >
            <img
              v-if="winner.game.id"
              :data-src="`/image-cdn/ss/i/s4/${winner.game.id}.webp`"
              :alt="winner.game.id"
              :src="`/image-cdn/ss/i/s4/${winner.game.id}.webp`"
              :class="$style.winnersMainPageSliderImage"
              width="90"
              height="48"
            />
            <div :class="$style.winnersMainPageSliderInfo">
              <p :class="$style.winnersMainPageSliderName">{{ winner.player.nickname }}</p>
              <p :class="$style.winnersMainPageSliderMoney">{{ winner.prize }}</p>
              <p :class="$style.winnersMainPageSliderGameName">{{ winner.game.title }}</p>
            </div>
          </a>
        </transition-group>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BitTableWrapper, BitTabButton, BitMenuScrollable } from '@bit/ui-kit';

import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import WinnersNowItemSkeleton from '~/components/lib/skeleton/winnersNowItemSkeleton.vue';
import { useUrlConstructor } from '~/composables/useUrlConstructor';
import { useStorePopups } from '~/stores/abstract/popups';
import { useStoreRoot } from '~/stores/abstract/root';
import { useStoreTopWinners } from '~/stores/softswiss/topWinners';
import { useStoreWinnersList } from '~/stores/softswiss/winnersList';
import { useStoreCataloguePage } from '~/stores/strapi/cataloguePage';
import { useStoreCurrencyMenu } from '~/stores/strapi/currencyMenu';
import type { ISsWinnersSlider } from '~/types/softswiss/ssWinners';

enum WinnerTabsType {
  Latest = 'latest',
  Top = 'top',
}

const props = defineProps({
  gtmCategory: {
    type: String,
    required: true,
  },
  gtmAction: {
    type: String,
    required: true,
  },
  direction: {
    type: String as PropType<'vertical' | 'horizontal'>,
    default: 'horizontal',
  },
  openGameByEmit: {
    type: Boolean,
    default: false,
  },
  numberOfWinners: {
    type: Number,
    default: null,
  },
  variant: {
    type: String as PropType<'table'>,
    default: '',
  },
});
const emit = defineEmits<{
  (e: 'openGame', value: any): void;
}>();
const storeWinnersList = useStoreWinnersList();
const storeTopWinners = useStoreTopWinners();
const storePopups = useStorePopups();
const storeCataloguePage = useStoreCataloguePage();
const storeRoot = useStoreRoot();
const storeCurrencyMenu = useStoreCurrencyMenu();
const { getGameUrl } = useUrlConstructor();

const sliderTab = ref<WinnerTabsType>(WinnerTabsType.Latest);
const winnersList = ref<ISsWinnersSlider[]>([]);
const topWinnersLastIndex = ref(0);
const isLoading = ref(true);
/**
 * id for interval which requests winners
 */
const intervalId = ref<number>(NaN);

const setWinnersTab = (tab: WinnerTabsType) => {
  stopDataUpdate();
  sliderTab.value = tab;
  winnersList.value = [];
  setTimeout(addWinner, 1000);
  startWinnerInterval();
};

const winners = computed((): ISsWinnersSlider[] =>
  sliderTab.value === WinnerTabsType.Latest
    ? storeWinnersList.latestWinners
    : storeTopWinners.topWinners
);

const countOfWinnersToShow = computed(() => {
  if (props.numberOfWinners) {
    return props.numberOfWinners;
  }
  if (storeRoot.screen.width > 1920) {
    return 8;
  } else if (storeRoot.screen.width <= 1920 && storeRoot.screen.width > 1440) {
    return 6;
  } else if (storeRoot.screen.width <= 1440 && storeRoot.screen.width > 1240) {
    return 4;
  } else if (storeRoot.screen.width <= 1240 && storeRoot.screen.width > 768) {
    return 3;
  } else {
    return 3;
  }
});

const winnersListWithLinks = computed(() => {
  return winnersList.value.map((winner) => {
    return {
      ...winner,
      gameFullPath:
        winner.game && winner.game.id
          ? getGameUrl({
              id: winner.game.id,
              provider: winner.game.provider,
              title: winner.game.title,
            })
          : useStoreRoot().localePath('/'),
    };
  });
});

const openGame = (game: any) => {
  if (props.openGameByEmit) {
    emit('openGame', game);
    return;
  }
  const path =
    game && game.id
      ? getGameUrl({ id: game.id, provider: game.provider, title: game.title })
      : useStoreRoot().localePath('/');

  return navigateTo({
    path,
  });
};

const addWinner = () => {
  const winnersCountToAdd =
    winnersList.value.length >= countOfWinnersToShow.value
      ? 1
      : countOfWinnersToShow.value - winnersList.value.length;

  let newWinners = [] as ISsWinnersSlider[];

  if (sliderTab.value === WinnerTabsType.Latest) {
    newWinners = winners.value
      // remove players which already in list (for dinamically change of list)
      .filter((w) => !winnersList.value.find((wl) => wl.id === w.id))
      // GET count of winners what we want to add
      .slice(-winnersCountToAdd);
  } else {
    newWinners = winners.value.slice(
      topWinnersLastIndex.value,
      topWinnersLastIndex.value + winnersCountToAdd
    );

    if (topWinnersLastIndex.value < winners.value.length - 1) {
      topWinnersLastIndex.value += winnersCountToAdd;
    } else {
      topWinnersLastIndex.value = 0;
    }
  }

  if (newWinners.length) {
    winnersList.value = [...newWinners, ...winnersList.value].slice(0, countOfWinnersToShow.value);
  }
};

/**
 * Method for run a cyclic call.
 * Nested setTimeout allows setting the delay between
 * the executions more precisely than setInterval.
 **/
const startWinnerInterval = () => {
  if (import.meta.browser && window) {
    if (sliderTab.value === WinnerTabsType.Top) {
      storeTopWinners.subscribeWinners();
    } else {
      storeWinnersList.subscribeWinners();
    }

    intervalId.value = window.setInterval(() => {
      addWinner();
    }, 5000);
  }
};

const loadDataAndAddWinner = async () => {
  isLoading.value = true;
  await Promise.all([
    storeWinnersList.latestWinners.length > 0 ? null : storeWinnersList.load(),
    storeTopWinners.topWinners.length > 0 ? null : storeTopWinners.load(),
  ]);

  addWinner();
  isLoading.value = false;
};

const stopDataUpdate = () => {
  if (import.meta.browser && window) {
    clearTimeout(intervalId.value);
  }

  storeWinnersList.unsubscribeWinners();
  storeTopWinners.unsubscribeWinners();
};

const handleVisibleCallback = async (isVisible: boolean, _entry: any) => {
  if (isVisible && !storePopups.isLoaderOpened) {
    await loadDataAndAddWinner();
    startWinnerInterval();
  } else {
    stopDataUpdate();
  }
};

const getCurrencyIconUrl = (code: string) => {
  return (
    storeCurrencyMenu.currencies.find((ac) => ac.currencyCode === code)?.currencyIcon.url || ''
  );
};

onBeforeMount(() => loadDataAndAddWinner());
onBeforeUnmount(() => stopDataUpdate());
</script>

<style lang="scss" module src="./winnersNowSliderMainPage.scss"></style>
<style lang="scss" scoped>
.vertical {
  .list-complete-enter-from {
    transform: translateY(-273px);
  }
  .list-complete-leave-active {
    transition: all 0.2s ease-in-out;
    position: absolute;
    transform: translateY(100vw);
    width: 100%;
  }
}

.variant-table {
  .list-complete-table-move,
  .list-complete-table-enter-active,
  .list-complete-table-leave-active {
    transition: all 0.5s ease;
  }
  .list-complete-table-enter-from {
    opacity: 0;
    transform: translateY(-30px);
  }
  .list-complete-table-leave-to {
    opacity: 0;
    transform: translateY(30px);
  }
  .list-complete-table-leave-active {
    width: 100%;
    position: absolute;
  }
}
.list-complete-enter-from {
  transform: translateY(-273px);

  @include mediaBreakpointUp('smx') {
    transform: translateX(-273px);
  }
}
.list-complete-enter-from,
.list-complete-leave-to {
  opacity: 0;
}
.list-complete-leave-active {
  position: absolute;
  transform: translateY(100vw);
  width: 100%;
  @include mediaBreakpointUp('smx') {
    transform: translateX(100vw);
    width: auto;
  }
}
.list-complete-enter-active {
  transition: all 0.2s ease-in-out;
}
.list-complete-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.myGamesCategoryTabs {
  display: flex;
  width: fit-content;

  .myGamesTabButton {
    width: 100%;
    white-space: nowrap;
    .tabIcon {
      opacity: 0.2;
      transition: $global-transition;
      max-width: unset;
    }
    &:global(.active) {
      .tabIcon {
        opacity: 1;
      }
    }
    &:hover {
      @include mediaBreakpointUp('lg') {
        opacity: 1;
        .tabIcon {
          opacity: 1;
        }
      }
    }
  }
}
</style>
